import { render, staticRenderFns } from "./PileCard.vue?vue&type=template&id=3517dcf1&scoped=true"
import script from "./PileCard.vue?vue&type=script&lang=js"
export * from "./PileCard.vue?vue&type=script&lang=js"
import style0 from "./PileCard.vue?vue&type=style&index=0&id=3517dcf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3517dcf1",
  null
  
)

export default component.exports